
const mastfoot = {

  init: function () {
    const _this = this;

    return new Promise(resolve => {
      this.resize();
      window.addEventListener('resize', _this.resize.bind(_this));
      document.addEventListener('_page_loaded', _this.resize.bind(_this));

      resolve();
    });
  },

  resize: function () {
    const _this = this;

    _this.setBottomBarPadding();
  },

  setBottomBarPadding: function () {
    const mastfoot = document.getElementById('mastfoot');
    const bourseFixed = document.querySelectorAll('.bourse__aside__toggle');

    if (bourseFixed) {
      let height = 0;

      bourseFixed.forEach(ele => {
        if (ele.clientHeight > height)
          height = ele.clientHeight;
      });

      mastfoot.style.paddingBottom = height + 'px';
    }
    else
      mastfoot.style.paddingBottom = 0;
  }

};


(function (window, $) {
  'use strict';

  $(document).ready(function () {
    mastfoot.init();
  });

  window.mastfoot = mastfoot;

})(window, jQuery);